import React from "react";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";

export default function Layout({ children }) {
  return (
    <div>
      <Navbar />
      {children}
      <Footer />

      {/* ✅ həmişə ekranda görünəcək (scroll ilə də yerində qalır) */}
      <FloatingActions />
    </div>
  );
}
